// removed by extract-text-webpack-plugin
module.exports = {"regular":"weight__regular___3ccQ- fontWeight-4","semibold":"weight__semibold___19uxy fontWeight-5","medium":"weight__medium___2falM fontWeight-5","bold":"weight__bold___hnlF6 fontWeight-6"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-heading/Heading/style/weight.css
// module id = 162
// module chunks = 0 21